export default {"src":"/_next/static/media/constLogo2.604bd030.svg","height":65,"width":107,"blurWidth":0,"blurHeight":0};